import { CircularProgress, Typography } from '@mui/material';
import { useState } from 'react';

import { Constants } from '../../constants';
import {
  ButtonBox,
  DialogContainer,
  FilledButton,
  OutlinedButton,
  RejectTextField,
  StyledDialog,
} from './styles';

interface RejectConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  loading: boolean;
  osNumber: number;
}

export function RejectConfirmationDialog({
  open,
  onClose,
  onConfirm,
  loading,
  osNumber,
}: RejectConfirmationDialogProps): JSX.Element {
  const [reason, setReason] = useState('');

  const handleClose = (): void => {
    setReason('');
    onClose();
  };

  const handleConfirm = (): void => {
    onConfirm(reason);
    onClose();
  };

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="reject-os-dialog"
    >
      <DialogContainer>
        <Typography fontWeight={700} fontSize={20}>
          {Constants.rejectTitle} {osNumber}
        </Typography>
        <Typography>{Constants.rejectConfirmText}</Typography>
        <Typography mb="-8px">{Constants.rejectReasonLabel}</Typography>
        <RejectTextField
          placeholder={Constants.rejectReasonPlaceholder}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          multiline
          rows={4}
          fullWidth
          disabled={loading}
          inputProps={{ maxLength: 300 }}
        />
        <ButtonBox>
          <OutlinedButton onClick={handleClose} disabled={loading}>
            {Constants.cancel}
          </OutlinedButton>
          <FilledButton
            onClick={handleConfirm}
            disabled={loading || reason.length < 6}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              Constants.confirm
            )}
          </FilledButton>
        </ButtonBox>
      </DialogContainer>
    </StyledDialog>
  );
}
